import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const COMPANY_DELETE_RESOURCE = "company" as const;
export const COMPANY_DELETE_API_PATH = `/v1/${COMPANY_DELETE_RESOURCE}/{uuid}` as const;

export type CompanyDeleteResponse =
  paths[typeof COMPANY_DELETE_API_PATH]["delete"]["responses"][200]["content"]["application/json"];

export const useCompanyDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<CompanyDeleteResponse, Error, { uuid: string; force?: boolean }>({
    mutationFn: async ({ uuid, force }) => {
      const response = await alphartisApiAxios.delete<CompanyDeleteResponse>(`/v1/${COMPANY_DELETE_RESOURCE}/${uuid}`, {
        params: { force },
      });
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [COMPANY_DELETE_RESOURCE],
      });
    },
  });
};
